import { Search } from '@components/shared/search/Search';
import { FilterContext } from '@features/campaign-list/stores/filter-context';
import { faFilters } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Stack } from '@mui/material';
import { useDebouncedFn } from '@utils/hooks';
import { MouseEvent, useContext, useState } from 'react';
import { Popup } from './Popup';
import { SelectionChips } from './SelectionChips';

const DEBOUNCE_DELAY_MS = 500;

export const Filters = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const popupOpen = Boolean(anchorEl);
  const { filterState, dispatch } = useContext(FilterContext);
  const debouncedDispatch = useDebouncedFn(dispatch, DEBOUNCE_DELAY_MS);

  const handleOpen = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleFilterChange = (newValue: string) => {
    debouncedDispatch({ type: 'search_text_changed', payload: newValue });
  };

  return (
    <Stack
      direction="row"
      gap="0.5rem"
      marginTop="1rem"
      marginBottom="0.5rem"
      justifyContent="center"
      alignItems="center"
    >
      <IconButton onClick={handleOpen}>
        <FontAwesomeIcon icon={faFilters} style={{ height: '1rem' }} />
      </IconButton>
      <Popup
        anchorEl={anchorEl}
        open={popupOpen}
        onClose={() => setAnchorEl(null)}
      />
      <SelectionChips />
      <Search
        onChange={e => handleFilterChange(e.target.value)}
        value={filterState.searchText}
        textFieldProps={{ sx: { marginLeft: 'auto', width: '20rem' } }}
      />
    </Stack>
  );
};
